import { useState } from "react";
import { useConfirmDialog } from "@/components/ui/confirm-dialog";
import { useToast } from "@/contexts/ToastContext";
import { paidAccessApi } from "@/lib/api/paid-access";

export type EntitlementRow = Awaited<ReturnType<typeof paidAccessApi.listEntitlements>>[number];

export function useRevokeEntitlement(onRevoked: () => void) {
  const toast = useToast();
  const { confirm, ConfirmDialog: ConfirmDialogComponent } = useConfirmDialog();
  const [revokingId, setRevokingId] = useState<string | null>(null);

  const revoke = (row: EntitlementRow) => {
    confirm({
      title: "Revoke access?",
      description:
        "The patron will lose download access immediately. This does not issue a refund.",
      confirmLabel: "Revoke",
      variant: "danger",
      onConfirm: async () => {
        setRevokingId(row.id);
        try {
          await paidAccessApi.revokeEntitlement(row.id);
          toast.success("Entitlement revoked.");
          onRevoked();
        } catch {
          toast.error("Could not revoke entitlement.");
        } finally {
          setRevokingId(null);
        }
      },
    });
  };

  return { revoke, revokingId, ConfirmDialogComponent };
}
